import React from 'react';
import { RateCalendarRecord } from 'types/Rate';
import { PricingModelsOptions } from 'utils/constants';
import { convertCentsToDisplayPrice } from 'utils/currency';
import { formatDate } from 'utils/helpers';
import styles from './RatesCalendar.module.css';
import { getTimeFormat } from 'utils/date';

function RateInfo({ rate }: { rate: RateCalendarRecord }) {
    const startDate = new Date(rate.start);
    const endTime = rate.end ? getTimeFormat(new Date(rate.end)) : null;
    return (
        <div className={styles.modal}>
            <p className={styles.date}>
                {formatDate(startDate)}, {startDate.getFullYear()}
            </p>
            <div className={styles.content}>
                <p>
                    Pricing Model:{' '}
                    <span>{rate.pricing_model_type?.replace('_', ' ') || PricingModelsOptions.STATIC}</span>
                </p>
                <p>
                    Price:{' '}
                    <span>
                        {convertCentsToDisplayPrice(rate.price)} {rate.unit}
                    </span>
                </p>
                {rate.dynamic_daily_max && (
                    <p>
                        Daily Max: <span>{convertCentsToDisplayPrice(rate.dynamic_daily_max)}</span>
                    </p>
                )}
                <p>
                    Schedule: <span>{rate.interval.replace('_', ' ')}</span>
                </p>
                <p>
                    Start Time: <span>{getTimeFormat(startDate)}</span>
                </p>
                {endTime && (
                    <p>
                        End Time: <span>{endTime}</span>
                    </p>
                )}
                <p>
                    Priority: <span>{rate.priority}</span>
                </p>
            </div>
        </div>
    );
}

export default RateInfo;
